// TODO: add test to make sure all routes are implemented in RoutesStore

/* eslint typescript-sort-keys/string-enum: "error" */
import { FilterEnumByPrefix } from "@/types/utils/GenericUtilityTypes";

export enum VignetteRoutes {
  Agency = "AgencyDetails",
  Briefcase = "Briefcase",
  BriefcaseFolder = "BriefcaseFolder",
  BrowseByAgency = "BrowseByAgency",
  BrowseByGroup = "BrowseByGroup",
  BrowseByState = "BrowseByState",
  Caucus = "CaucusDetails",
  Committee = "CommitteeDetails",
  Debug = "Debug",
  District = "DistrictDetails",
  Faq = "Faq",
  Forgot = "Forgot",
  Home = "Home",
  Loading = "Loading",
  LoginRedirect = "LoginRedirect",
  MyAccount = "MyAccount",
  NotFound = "NotFound",
  PayWall = "PayWall",
  Profile = "Profile",
  ProfileKW = "ProfileKW",
  ProfileLanding = "ProfileLanding",
  SearchCongressional = "SearchCongressional",
  SearchFederal = "SearchFederal",
  SearchState = "SearchState",
  SearchUniversal = "SearchUniversal",
  State = "StateDetails",
  Welcome = "Welcome",
}

export type SearchRoutes = FilterEnumByPrefix<typeof VignetteRoutes, "Search">;

/**
 * Utility type to return all the routes related to search and returns the name without "Search"
 */
type ExtractSearchRoutes<T extends string> = T extends `Search${infer U}`
  ? U
  : never;

/**
 * The actual string value of the search routes ex: "Congressional", "Federal", "State", "Universal"
 */
export type SearchRouteTypes = ExtractSearchRoutes<keyof typeof VignetteRoutes>;

export type SearchRoute = ExtractSearchRoutes<VignetteRoutes>;
